import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';

import { ActionContainer, Layouts, SubmitButton } from 'components';
import { Main } from '../components';
import Logout from 'startup/protected/Logout';

const Suspended: FC = () => {
  const [logout, setLogout] = useState(false);
  const { t } = useTranslation();

  if (logout) {
    return <Logout />;
  }

  function renderSidebar() {
    return (
      <Grid container direction="column">
        <Grid item>
          <Typography gutterBottom variant="h4" color="textSecondary">
            {t('auth:userSuspended')}
          </Typography>
        </Grid>
        <Grid item>
          <ActionContainer>
            <SubmitButton onClick={() => setLogout(true)} text={t('common:logout')} />
          </ActionContainer>
        </Grid>
      </Grid>
    );
  }

  return (
    <Layouts.Full2Column
      sidebar={renderSidebar()}
      main={<Main headerI18nKey="auth:bodyHeader1" subHeaderI18nKey="auth:signInSubHeader" />}
    />
  );
};

export default Suspended;
